export { EtiquetteViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
